import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import { AddressBookList } from "./addressBookList";
import { AddNewAddress } from "./AddNewAddress";
import { PAGES } from "../../../routeConfig";
import { CSSTransition, SwitchTransition } from "react-transition-group";

export const MyAddressBookMain = () => {
  const [editAddId, setEditAddId] = useState(null);
  const [breadCrumb, setBreadCrumb] = useState(null);
  const { type, editId } = useParams();
  useEffect(() => {
    if (type == "edit" && editId) {
      setEditAddId(parseInt(editId));
      setBreadCrumb([
        { name: "My Account", url: PAGES.MYACCOUNT },
        { name: "Shipping Address Book", url: PAGES.MYADDRESSBOOK },
        { name: "Edit Address", url: "" },
      ]);
    } else if (type == "new" || type == "add") {
      setEditAddId(0);
      setBreadCrumb([
        { name: "My Account", url: PAGES.MYACCOUNT },
        { name: "Shipping Address Book", url: PAGES.MYADDRESSBOOK },
        {
          name: "Add Shipping Address",
          url: "",
        },
      ]);
    } else {
      setEditAddId(null);
      setBreadCrumb([
        { name: "My Account", url: PAGES.MYACCOUNT },
        { name: "Shipping Address Book", url: "" },
      ]);
    }
  }, [type, editId]);
  return (
    <Fragment>
      <BreadCrumb data={breadCrumb} />
      <div className="row css-transaction">
        <SwitchTransition mode="out-in">
          <CSSTransition key={editAddId == null ? "list" : "form"} timeout={300} classNames="fade">
            {editAddId == null ? <AddressBookList /> : <AddNewAddress id={parseInt(editAddId)} />}
          </CSSTransition>
        </SwitchTransition>
      </div>
    </Fragment>
  );
};
